import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import * as moment from 'moment/moment';
import { ClaimRegistrationService } from '../../../../BaseFramework/core/http/claim-registration.service';
import {
  InteractService, ApiRequestService, UserInfoService, AppMetadataHandler
} from 'app'
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: true;
  isMandatory: Boolean;
}
@Component({
  selector: 'search-registration',
  templateUrl: './search-registration.component.html',
  styleUrls: ['./search-registration.component.scss']
})
export class SearchRegistrationComponent implements OnInit {

  public searchResultList = []
  public CRITERIALOOKUP = [];
  public dataSet = [];
  public viewType = null
  constructor(private router: Router,
    private claimRegistrationService: ClaimRegistrationService,
    private userInfoService: UserInfoService,
    private apiRequestService: ApiRequestService,
    private interactService: InteractService,
    private activatedRoute: ActivatedRoute,
    public appMetadataHandler: AppMetadataHandler) { }

  ngOnInit() {
    this.activatedRoute.data.subscribe(data => {
      this.viewType = data.viewType
    });
    this.getClaimRegistrationCriteriaList();
    this.getLatestFiveRegistration(); // Will take latest five  registration
  }

  public registrationZeroState = {
    title: "Search Required",
    message: "Hit search to view results",
    icon: "file-search"
  }


  fetchSearchResult($event) {
    this.dataSet = $event.results;

    if (!this.dataSet || (this.dataSet && this.dataSet.length == 0)) {
      this.registrationZeroState.title = "No Results found"
      this.registrationZeroState.message = "No records available for the selected search criteria."
    }
    console.log(this.dataSet)
  }

  getClaimRegistrationCriteriaList() {
    var me = this;
    this.claimRegistrationService.fetchAPIMetaData('searchClaim')
      .subscribe(jsonResp => {
        if (jsonResp && typeof jsonResp === typeof []) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }

  NewRegistration() {
    this.interactService.openNewTransaction('claimRegistration', null, null);
    //this.router.navigateByUrl("/app/claims/transaction/details")
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }
  openTransactionDetails(serviceTask: any, entityGuid: any, inboxType: any) {
    let transactionDataIO: any = [];
    this.claimRegistrationService.getClaimDataByGuid(entityGuid).
      subscribe(resp => {
        transactionDataIO = resp;
        this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, null, null, inboxType)
        if (this.viewType == "ENQUIRY")
          this.router.navigate(['/app/claims/transaction/enquiry'], { queryParams: {}, replaceUrl: false });
        else
          this.router.navigate(['/app/claims/transaction/details'], { queryParams: {}, replaceUrl: false });
      });
  }


  itemsPerPage: any = 5;
  currentPage: any
  searchURL = "claim/registration/search"
  getLatestFiveRegistration() {
    var payload = {}
    payload["page"] = this.currentPage = 1
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem = {}
    let userId = null
    userId = this.userInfoService.getUserId();
    criteriaItem = {}
    criteriaItem["paramName"] = 'criteriaUser'
    criteriaItem["paramValue"] = userId
    payload["searchCriteriaList"].push(criteriaItem)
    this.apiRequestService.post(this.searchURL, payload).subscribe(data => {
      this.dataSet = data.results;

    });

  }

}

